import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AdminMessage } from '../../messages/models/admin-message';

@Injectable()
export class AdminSharedService {
    changeTabEvent = new EventEmitter<string>();
    messageSentEvent = new EventEmitter<void>();
    messageDeletedEvent = new EventEmitter<void>();
    messageCopyEvent = new EventEmitter<AdminMessage>();

    onChangeTab(tabName: string): Observable<void> {
        this.changeTabEvent.emit(tabName);
        return of();
    }

    onMessageSentSuccess(): Observable<void> {
        this.messageSentEvent.emit();
        return of();
    }

    onMessageDeletedSuccess(): Observable<void> {
        this.messageDeletedEvent.emit();
        return of();
    }

    onMessageCopy(message: AdminMessage) {
        this.messageCopyEvent.emit(message);
        return of();
    }
}
